import { LogoutApiResponse } from '@omecare/utils';
import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import http from '@/utils/http.service';

const useLogoutMutation = (): UseMutationResult<
  LogoutApiResponse,
  Error,
  void
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => http.auth.logout(),
    onSuccess() {
      queryClient.removeQueries();
      // @comment: prbl cannot use navigate in sheet
      // -> not router is not provided
      // -> sheet injected outside router in main.tsx
      window.location.pathname = '/login';
    },
  });
};

export default useLogoutMutation;
